import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"
import { api } from "../helpers/utils"

// New clients share /vibes/:id and /plans/:id, so `kind` is known from the route.
// Old clients share /uservibes/:id for both, so the details call decides which page to show.
function UserVibes({ kind }) {
  const { id } = useParams()
  const inviteCode = new URLSearchParams(useLocation().search).get("code")
  const query = inviteCode ? `?code=${encodeURIComponent(inviteCode)}` : ""
  const [vibe, setVibe] = useState(null)

  useEffect(() => {
    api.post("/get-user-vibe-details-web", { userVibeId: id })
      .then((res) => setVibe(res.data?.vibeDetails || null))
      .catch(() => setVibe(null))
  }, [id])

  const isPlan = kind ? kind === "plan" : vibe?.type === "plan"
  const details = vibe && {
    title: vibe.vibeTitle,
    description: vibe.vibeDesc,
    tag: isPlan ? vibe.whenLabel : vibe.isStartedNow ? "● happening now" : null,
  }
  const deepLink = kind ? `pepchat://${kind}s/${id}${query}` : `pepchat://uservibes/${id}${query}`

  return <AppRedirectScreen type={isPlan ? "plan" : "vibe"} deepLink={deepLink} details={details} />
}

export default UserVibes
